import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import Box from '@mui/material/Box';

import SectionCard from '../../../positionTemplate/components/SectionCard';
import { toIds } from '../../helpers';
import EntityChipsField from '../EntityChipsField';
import FieldLabel from '../FieldLabel';
import SaveStatusIndicator from '../SaveStatusIndicator';
import SectionTitle from '../SectionTitle';

const rootSx = { display: 'flex', flexDirection: 'column', gap: '20px', padding: '8px 0 16px' };

const fieldSx = { display: 'flex', flexDirection: 'column', gap: '8px' };

const labelRowSx = { alignItems: 'center', display: 'flex', justifyContent: 'space-between' };

const nameFilter = (searchTerm) =>
  searchTerm ? [{ field: 'name', operation: 'icontains', value: searchTerm }] : [];

const RequirementsCard = ({ positionTemplate, saveField, getStatus }) => {
  const intl = useIntl();
  const t = (id) => intl.formatMessage({ id });

  const buildCertificationSearch = useCallback(
    (searchTerm) => ({
      filters: [
        { field: 'state.status', operation: 'equals', value: 'active' },
        ...nameFilter(searchTerm),
      ],
    }),
    []
  );
  const buildSkillSearch = useCallback((searchTerm) => ({ filters: nameFilter(searchTerm) }), []);

  const saveList = (field) => (entities) =>
    saveField({ key: field, fields: { [field]: toIds(entities) }, patch: { [field]: entities } });

  return (
    <SectionCard header={<SectionTitle>{t('pt.detail.requirements.title')}</SectionTitle>}>
      <Box sx={rootSx}>
        {[
          {
            field: 'certifications',
            route: 'certifications/read',
            buildRequestData: buildCertificationSearch,
            helperText: t('pt.detail.requirements.certifications.helper'),
          },
          { field: 'skills', route: 'skills/read', buildRequestData: buildSkillSearch },
        ].map(({ field, route, buildRequestData, helperText }) => (
          <Box key={field} sx={fieldSx}>
            <Box sx={labelRowSx}>
              <FieldLabel>{t(`pt.detail.requirements.${field}`)}</FieldLabel>
              <SaveStatusIndicator status={getStatus(field)} />
            </Box>
            <EntityChipsField
              testId={`pt-detail-add-${field}`}
              entities={positionTemplate[field]}
              placeholder={t(`pt.detail.requirements.${field}.search`)}
              route={route}
              buildRequestData={buildRequestData}
              onSave={saveList(field)}
              helperText={helperText}
            />
          </Box>
        ))}
      </Box>
    </SectionCard>
  );
};

RequirementsCard.propTypes = {
  positionTemplate: PropTypes.shape({
    certifications: PropTypes.arrayOf(PropTypes.shape({})),
    skills: PropTypes.arrayOf(PropTypes.shape({})),
  }).isRequired,
  saveField: PropTypes.func.isRequired,
  getStatus: PropTypes.func.isRequired,
};

export default RequirementsCard;
